import React from 'react';
import { Profiles } from '../components';

export const Page: React.FC = () => <Profiles />;
